export default __webpack_public_path__ + "static/media/katie_allen.eed7e3c7.jpg";